import type { ReactNode } from 'react';

/** KPI kartı (§1.7). `accent` verilirse kenar rengi değişir (dikkat çeken KPI). */
export function Kpi({
  label,
  value,
  note,
  accent,
  onClick,
}: {
  label: string;
  value: ReactNode;
  note?: ReactNode;
  accent?: 'warning' | 'danger';
  onClick?: () => void;
}) {
  const border =
    accent === 'warning'
      ? 'var(--warning)'
      : accent === 'danger'
        ? 'var(--danger)'
        : 'var(--border)';
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      className="card"
      style={{
        padding: 20,
        borderColor: border,
        textAlign: 'left',
        display: 'block',
        width: '100%',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <div style={{ fontWeight: 500, fontSize: 13, color: 'var(--text-secondary)' }}>{label}</div>
      <div className="kpi-number" style={{ margin: '10px 0 8px' }}>
        {value}
      </div>
      {note && <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{note}</div>}
    </Tag>
  );
}
